VjsAdmin.Etx = (function () {
    const init = function () {
        initDateRangePickers();
        new EtxEditController();
    };

    let EtxEditController = VjsUtility.Controller.extend({
        events: {
            'click #save-etx-button': 'clickSaveEtxButton',
            'click #etx_address_same': 'billingAddressAutofill',
            'change #enable-etx-test-mode': 'changeTestMode',
        },
        changeTestMode(e) {
            const pageForm = document.querySelector('#etx-form');
            const apiData = {
                license_id: pageForm.dataset.licenseId,
                platform_id: pageForm.dataset.platformId,
                district_id: pageForm.dataset.districtId,
                test_mode: e.target.checked,
            };
            const req = new VjsUtility.Request();
            req.put(Slim.Router.pathFor('api.license.edit.etx.test.mode'), apiData)
                .done((res) => {
                    console.log('success res', res);
                    VjsUtility.Notification.success({
                        text: 'ETX setting successfully updated',
                        time: 3500,
                    });
                })
                .fail((res) => {
                    console.log(res);
                    VjsUtility.Notification.error({
                        text: 'Error updating ETX settings',
                        time: 3500,
                    });
                });
        },
        clickSaveEtxButton() {
            const etxFormData = {
                license_id: document.getElementById('etx-form').dataset.licenseId,
                platform_id: document.getElementById('etx-form').dataset.platformId,
                district_id: document.getElementById('etx-form').dataset.districtId,
                enable_etx: document.getElementById('enable_etx').checked ? 1 : 0,
            };
            // pull the rest of the fields from the form, minus the etx prefix
            $('#etx-form')
                .serializeArray()
                .forEach((input) => {
                    etxFormData[input.name.replace('etx_', '')] = input.value;
                });
            const req = new VjsUtility.Request();
            req.put(Slim.Router.pathFor('api.license.edit.etx.license.settings'), etxFormData)
                .done(() => {
                    VjsUtility.Notification.success({
                        text: 'ETX setting successfully updated',
                        time: 3500,
                    });
                })
                .fail(() => {
                    VjsUtility.Notification.error({
                        text: 'Error updating ETX settings',
                        time: 3500,
                    });
                });
        },
        billingAddressAutofill() {
            $('#etx_billing_address_1').val($('#etx_school_address_1').val());
            $('#etx_billing_address_2').val($('#etx_school_address_2').val());
            $('#etx_billing_state').val($('#etx_school_state').val());
            $('#etx_billing_city').val($('#etx_school_city').val());
            $('#etx_billing_zip').val($('#etx_school_zip').val());
        },
    });

    let initDateRangePickers = function () {
        const form = $('#etx-form');
        $(form)
            .find('.datetimepicker')
            .each(function () {
                const originalDateValue = $(this).find('input').attr('value');

                $(this).datetimepicker({
                    useCurrent: false,
                    format: 'MM/DD/YYYY',
                    maxDate: moment.utc('2038-01-19 03:14:06'), // prevent errors from y2k38 bug
                    icons: {
                        date: 'fa fa-calendar',
                        previous: 'fa fa-hand-o-left',
                        next: 'fa fa-hand-o-right',
                    },
                });
                $(this).find('input').val(originalDateValue);
            });

        $(form)
            .find('.datetimepicker')
            .on('click', 'input', () => {
                $(form).find('.datetimepicker').data('DateTimePicker').show();
            });
    };

    return {
        init,
    };
}());
